/**
 * Основной номер производителя за словом состояния: «Фара · контрактная ·
 * 84140-12530 · № 347» (задача 0327, решение владельца продукта «7 - а»).
 *
 * <p>Наименования и слова состояния мало: «Фара левая Toyota Camry ·
 * контрактная» бывает не одна, а деталь опознают по номеру. Отказ называл
 * номер с 0320, список, из которого позицию выбирали, — нет.
 *
 * <p>Номер — как хранится («84140-12530»), не приведённый. Только основной:
 * кросс-номер сервер вместо него не отдаёт. Пусто — ничего, без висящего « · ».
 *
 * <p><b>Длина.</b> Колонка наименования на телефоне узкая (цена и кнопка
 * не сжимаются, и наименование там идёт по слову в строку), поэтому обрезка
 * по ширине резала бы и настоящий номер в 10–15 знаков до «8414…». Номер
 * переносится, как наименование, а обрезается только по числу знаков —
 * длиннее {@link OEM_SHOWN} (хранить можно до 1000, 0312): такое не номер,
 * а вставленное не туда, и строку списка оно занимать не должно. Полный
 * номер — в подсказке.
 */
export const OEM_SHOWN = 40;

/**
 * @param whole не обрезать (задача 0329, печать сделки): у бумаги нет
 *              подсказки, и обрезанный «…» номер покупатель не прочтёт
 *              никак — номер переносится по ширине клетки целиком
 */
export function OemWord({ number, whole = false }: {
  number: string | null | undefined;
  whole?: boolean;
}) {
  const value = number?.trim() ?? '';
  if (value === '') {
    return null;
  }
  const shown = !whole && value.length > OEM_SHOWN ? `${value.slice(0, OEM_SHOWN)}…` : value;
  return (
    <span className="muted">
      {' · '}
      <span className="oem-word" title={value}>{shown}</span>
    </span>
  );
}
